
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M9.06 21.97L20 38.15l10.94-16.18"}}),_c('path',{attrs:{"d":"M30.85 13.38h-.65a18.67 18.67 0 00.17-1.86A10.37 10.37 0 109.8 13.38h-.65a4.46 4.46 0 000 8.91h7.35v2.59a2.5 2.5 0 005 0v-2.59h9.35a4.46 4.46 0 000-8.91z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    